import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import Thanks from "@/pages/Thanks";
import Funnel from "@/pages/Funnel";
import Login from "./pages/Login";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import MockupPreview from "@/pages/MockupPreview";
import OwnerPreview from "@/pages/OwnerPreview";
import ActivationSuccess from "@/pages/ActivationSuccess";
import ClientPortal from "@/pages/ClientPortal";
import Training from "@/pages/Training";
import AdminMockups from "@/pages/admin/AdminMockups";
import AdminMockupEdit from "@/pages/admin/AdminMockupEdit";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminSuccessCenter from "@/pages/admin/AdminSuccessCenter";
import AdminPaidAds from "@/pages/admin/AdminPaidAds";
import AdminClientEmails from "@/pages/admin/AdminClientEmails";
import AdminManual from "./pages/admin/AdminManual";

import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B] text-white font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/training" element={<Training />} />
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/r/:slug" element={<Funnel />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/mockup/:slug" element={<MockupPreview />} />
          <Route path="/preview/:slug" element={<OwnerPreview />} />
          <Route path="/activation-success" element={<ActivationSuccess />} />
          <Route path="/client/:token" element={<ClientPortal />} />
          <Route path="/admin/mockups" element={<AdminMockups />} />
          <Route path="/admin/mockups/:id/edit" element={<AdminMockupEdit />} />
          <Route path="/staff/mockups" element={<AdminMockups staffMode={true} />} />
          <Route path="/staff/mockups/:id/edit" element={<AdminMockupEdit staffMode={true} />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/success-center" element={<AdminSuccessCenter />} />
          <Route path="/admin/paid-ads" element={<AdminPaidAds />} />
          <Route path="/admin/client-emails" element={<AdminClientEmails />} />
          <Route path="/admin/manual" element={<AdminManual />} />
          <Route path="/staff/leads" element={<AdminLeads staffMode={true} />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
